







import { Component, Vue } from 'vue-property-decorator'
import SanIDList from '@/components/sanid/SanIDList.vue'

@Component({
  components: {
    SanIDList
  }
})
export default class SanID extends Vue {}
